// Team Sales CRM
// Admin-only. Every screen renders inside the CRM shell, which owns the sidebar.

import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute';
import CrmLayout, { CrmSettingsContext } from './CrmLayout';
import Dashboard from './Dashboard';
import Pipeline from './Pipeline';
import Activity from './Activity';
import Organizations from './Organizations';
import OrganizationDetail from './OrganizationDetail';
import Contacts from './Contacts';
import Invoices from './Invoices';
import Reports from './Reports';
import Mail from './Mail';
import Settings from './Settings';

// /crm is only ever a redirect to the house "opening screen". The dashboard has its
// own address so the sidebar can always reach it -- when /crm rendered the dashboard
// directly, choosing any other opening screen made the dashboard unreachable.
const LANDING_PATHS = {
  dashboard: '/crm/dashboard',
  pipeline: '/crm/pipeline',
  organizations: '/crm/organizations',
  invoices: '/crm/invoices',
  reports: '/crm/reports',
};

const Landing = () => {
  const { settings, settingsLoaded } = useContext(CrmSettingsContext);
  if (!settingsLoaded) return null;
  return <Navigate to={LANDING_PATHS[settings.default_landing] || LANDING_PATHS.dashboard} replace />;
};

const screen = (Component) => (
  <ProtectedRoute requiredPermission="crm:read">
    <CrmLayout><Component /></CrmLayout>
  </ProtectedRoute>
);

const CrmApp = () => (
  <Routes>
    <Route path="/" element={screen(Landing)} />
    <Route path="/dashboard" element={screen(Dashboard)} />
    <Route path="/pipeline" element={screen(Pipeline)} />
    <Route path="/activity" element={screen(Activity)} />
    <Route path="/organizations" element={screen(Organizations)} />
    <Route path="/organizations/:id" element={screen(OrganizationDetail)} />
    <Route path="/contacts" element={screen(Contacts)} />
    <Route path="/invoices" element={screen(Invoices)} />
    <Route path="/reports" element={screen(Reports)} />
    <Route path="/email" element={screen(Mail)} />
    <Route path="/settings" element={screen(Settings)} />
    <Route path="*" element={<Navigate to="/crm" replace />} />
  </Routes>
);

export default CrmApp;
